// extracted by mini-css-extract-plugin
export default {"DivContainer":"WingsCard_DivContainer__isuM+","InlineDiv":"WingsCard_InlineDiv__DycG4","Title":"WingsCard_Title__R+9A9"};